<template>
  <div class="topbar">
    <div class="document-name-container">
      <BbIcon size="medium" name="preview" />
      <BbBtn size="large" type="tertiary">{{ title }}</BbBtn>
    </div>

    <div class="document-actions">
      <BbBtn size="small" type="secondary" :disabled="isDownloadInProgress" @click="onDownload">
        <BbIcon size="small" :name="isDownloadInProgress ? 'spin' : 'download'" />
        <TextBody :i18n-key="isDownloadInProgress ? 'common.processing' : 'common.download'" tag="span" />
      </BbBtn>
      <BbBtn size="x-small" type="icon" icon="x-small" icon-size="medium" no-background @click="onPreviewClose" />
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import TextBody from '~/components/common/TextBody';
import useConversations from '~/composables/useConversations';

import useDocuments from '~/composables/useDocuments';
import useModals from '~/composables/useModals';
import { IsDownloadInProgress } from '~/constants/getters';

export default {
  components: { TextBody },

  setup() {
    const route = useRoute();
    const store = useStore();

    const { downloadAuthoredDocument } = useDocuments();
    const { currentConversation } = useConversations();
    const { hidePreviewAuthorDocument } = useModals();

    const isDownloadInProgress = computed(() =>
      store.getters[`documentStore/${IsDownloadInProgress}`](route.params.conversationId),
    );

    const onDownload = async () => {
      if (isDownloadInProgress.value) {
        return;
      }

      await downloadAuthoredDocument(route.params.conversationId);
    };

    return {
      onDownload,
      onPreviewClose: hidePreviewAuthorDocument,
      title: currentConversation.value.title,
      isDownloadInProgress,
    };
  },
};
</script>

<style scoped lang="scss">
.topbar {
  padding: $bb-spacing-3;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: $bb-neutral-0;
  border-bottom: 1px solid $bb-neutral-4;

  .document-name-container {
    display: flex;
    align-items: center;
    gap: $bb-spacing-3;
  }

  .document-actions {
    display: flex;
    align-items: center;
    gap: $bb-spacing-2;

    :deep(.v-btn__content) {
      display: flex;
      align-items: center;
      gap: $bb-spacing-1;
    }
  }
}
</style>
